import { useTimezoneStore } from './useTimeZoneStore';

export const NewDateTime = {
  getTimeZone: () => useTimezoneStore.getState().timezone,
  formatDate: (date) => useTimezoneStore.getState().formatDate(date),
  toUserTzDate: (dateInput) => useTimezoneStore.getState().toUserTzDate(dateInput),
  getCurrentUserMidnight: () => useTimezoneStore.getState().getCurrentUserMidnight(),
};

export default NewDateTime;
